import { useMemo } from 'react';
export const useQueryParams = queryString => {
  return useMemo(() => {
    const params = new URLSearchParams(queryString !== null && queryString !== void 0 ? queryString : window.location.search);
    return Object.fromEntries(params.entries());
  }, [queryString]);
};